<!-- Section Mesures Pompe à chaleur -->
<app-collapse [title]="'P00062.status.mesure.pac' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00062.status.etatpac' | translate"
      [value]="
        'P00062.status.etatpac.' + getValue('ppSModeRegistreCommande')
          | translate
      "
    />

    <app-display-rubrique-status
      [title]="'P00062.status.temperature.eau.entrante' | translate"
      [value]="getTemperature(getValue('ppSTemperatureEauEntrante') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.temperature.eau.sortante' | translate"
      [value]="getTemperature(getValue('ppSTemperatureEauSortante') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.temperature.ambiante' | translate"
      [value]="getTemperature(getValue('ppSTemperatureAirAmbiant') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.tensionsecteur' | translate"
      [value]="getValue('ppSTensionAlimentation') + ' V'"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.courant' | translate"
      [value]="getValue('ppSCourantConsomme') / 10 + ' A'"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.puissance' | translate"
      [value]="getValue('ppSPuissanceActive') + ' W'"
    />
  </div>
</app-collapse>

<!-- Section Codes défauts Pompe à chaleur -->
<app-collapse
  [title]="'P00062.status.code.default' | translate"
  [warning]="codeDefautHasWarning"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00062.parameters.status.service.polytropic.title' | translate"
      [warning]="codeDefautHasWarning"
      [ctaText]="'P00062.parameters.status.service.polytropic.cta' | translate"
      [notWarning]="'--'"
      (onPress)="onPolySupportClick()"
    />

    @if (hasCodeDefaut) {
      <app-display-rubrique-status
        [title]="'P00062.status.code.default.pac' | translate"
        [value]="displayGoodDefault()"
      />
    }

    <app-display-rubrique-status
      [title]="'P00062.status.code.default.bypass' | translate"
      [value]="getBypassPacValue()"
    />
  </div>
</app-collapse>

<!-- Section Identification de la PAC -->
@if (isSupportTechnique()) {
  <app-collapse [title]="'P00062.status.identification' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="'P00062.status.link.support' | translate"
        [value]="additionalData?.ppIdentificationPACPoly || ''"
      />
    </div>
  </app-collapse>
}

<!-- Section Fonctionnement -->
@if (isSupportTechnique()) {
  <app-collapse [title]="'P00062.status.fonctionnement' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00062.status.fonctionnement.temperaturefcthorloge' | translate
        "
        [value]="getTemperatureFctHorloge()"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00062.status.fonctionnement.prioritepac' | translate"
        [value]="getValue('ppSMiseRouteFiltrationPriorite') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00062.status.fonctionnement.automaintient' | translate"
        [value]="getValue('ppSMiseRouteFiltrationAutoMaintien') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00062.status.fonctionnement.etatvolet' | translate"
        [value]="getEtatVoletValue()"
      />

      <app-display-rubrique-status
        [title]="'P00062.status.fonctionnement.resetusine' | translate"
        [value]="getValue('ppSCompteurResetUsine') + ''"
      />
    </div>
  </app-collapse>
}

<!-- Section Produit passerelle -->
<app-collapse
  [title]="'P00062.status.passerelle' | translate"
  [warning]="produitP00062 !== 1"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00062.status.passerelle.connexion' | translate"
      [warning]="produitP00062 !== 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00062.status.passerelle.dureetension' | translate"
      [value]="transformHourToDayHourLocal(getValue('ppSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P00062.status.passerelle.etatbouton' | translate"
        [value]="getValue('ppSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00062.status.passerelle.compteurbouton' | translate"
        [value]="(getValue('ppSCompteurBouton') || 0) + ''"
      />
    }
  </div>
</app-collapse>
